var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { type: "primary" } },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  inline: true,
                  "label-width": "100px",
                  "label-position": "left"
                },
                nativeOn: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessNo") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "210px" },
                      attrs: { no: "jobNo" },
                      model: {
                        value: _vm.search.jobNo,
                        callback: function($$v) {
                          _vm.$set(_vm.search, "jobNo", $$v)
                        },
                        expression: "search.jobNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("CargoMsg.Cargo_OperationProvince") }
                  },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "210px" },
                      attrs: {
                        no: "opProvince",
                        "select-type": _vm.TYPE_NAMES.basic_data_Office,
                        filterable: "",
                        "default-value": Number(_vm.search.opProvince),
                        cache: false,
                        "static-options": _vm.provinceList,
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.search.opProvince = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("CargoMsg.Cargo_OperationCompany") }
                  },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "210px" },
                      attrs: {
                        no: "opOffice",
                        "select-type": _vm.TYPE_NAMES.basic_data_Office,
                        filterable: "",
                        "default-value": Number(_vm.search.opOffice),
                        cache: false,
                        "static-options": _vm.officeList,
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.search.opOffice = p.value
                          _vm.reSetOp()
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_OperationDepartment")
                    }
                  },
                  [
                    _c("cargo-department-select", {
                      staticStyle: { width: "210px" },
                      attrs: {
                        no: "opDepartment",
                        "office-id":
                          Number(_vm.search.opOffice) ||
                          _vm.$store.getters.currentOfficeId,
                        "department-id": Number(_vm.search.opDepartment),
                        placeholder: " "
                      },
                      on: {
                        change: function(p) {
                          _vm.search.opDepartment = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_Operation") } },
                  [
                    _c("cargo-user-select", {
                      staticStyle: { width: "210px" },
                      attrs: {
                        no: "opId",
                        "method-params": {
                          officeId:
                            _vm.search.opOffice ||
                            _vm.$store.getters.currentOfficeId,
                          category: "role",
                          shape: "op"
                        },
                        "default-value": _vm.search.opId || "",
                        placeholder: " "
                      },
                      on: {
                        change: function(p) {
                          _vm.search.opId = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_SalesProvince") } },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "210px" },
                      attrs: {
                        no: "salesProvince",
                        "select-type": _vm.TYPE_NAMES.basic_data_Office,
                        filterable: "",
                        "default-value": Number(_vm.search.salesProvince),
                        cache: false,
                        "static-options": _vm.provinceList,
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.search.salesProvince = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_SalesCompany") } },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "210px" },
                      attrs: {
                        no: "salesOffice",
                        "select-type": _vm.TYPE_NAMES.basic_data_Office,
                        filterable: "",
                        "default-value": Number(_vm.search.salesOffice),
                        cache: false,
                        "static-options": _vm.officeList,
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.search.salesOffice = p.value
                          _vm.reSetSales()
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("CargoMsg.Cargo_SalesDepartment") }
                  },
                  [
                    _c("cargo-department-select", {
                      staticStyle: { width: "210px" },
                      attrs: {
                        no: "salesDept",
                        "office-id":
                          Number(_vm.search.salesOffice) ||
                          _vm.$store.getters.currentOfficeId,
                        "department-id": Number(_vm.search.salesDept),
                        placeholder: " "
                      },
                      on: {
                        change: function(p) {
                          _vm.search.salesDept = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_Sales") } },
                  [
                    _c("cargo-user-select", {
                      staticStyle: { width: "210px" },
                      attrs: {
                        no: "salesId",
                        "method-params": {
                          officeId:
                            _vm.search.salesOffice ||
                            _vm.$store.getters.currentOfficeId,
                          category: "role",
                          shape: "sales"
                        },
                        "default-value": _vm.search.salesId || "",
                        placeholder: " "
                      },
                      on: {
                        change: function(p) {
                          _vm.search.salesId = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_BLNo") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "210px" },
                      attrs: { no: "mbl" },
                      model: {
                        value: _vm.search.mbl,
                        callback: function($$v) {
                          _vm.$set(_vm.search, "mbl", $$v)
                        },
                        expression: "search.mbl"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_PushTime") } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "173px" },
                      attrs: {
                        no: "pushTimeStart",
                        "value-format": "yyyy-MM-dd",
                        placeholder: _vm.$t("SystemMonitor.StartDate")
                      },
                      model: {
                        value: _vm.search.pushTimeStart,
                        callback: function($$v) {
                          _vm.$set(_vm.search, "pushTimeStart", $$v)
                        },
                        expression: "search.pushTimeStart"
                      }
                    }),
                    _c(
                      "span",
                      { staticStyle: { color: "#dfe4ed", padding: "0 4px" } },
                      [_vm._v("—")]
                    ),
                    _c("el-date-picker", {
                      staticStyle: { width: "173px" },
                      attrs: {
                        no: "pushTimeEnd",
                        "value-format": "yyyy-MM-dd",
                        placeholder: _vm.$t("SystemMonitor.EndDate")
                      },
                      model: {
                        value: _vm.search.pushTimeEnd,
                        callback: function($$v) {
                          _vm.$set(_vm.search, "pushTimeEnd", $$v)
                        },
                        expression: "search.pushTimeEnd"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_ETD") } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "173px" },
                      attrs: {
                        no: "etdStart",
                        "value-format": "yyyy-MM-dd",
                        placeholder: _vm.$t("SystemMonitor.StartDate")
                      },
                      model: {
                        value: _vm.search.etdStart,
                        callback: function($$v) {
                          _vm.$set(_vm.search, "etdStart", $$v)
                        },
                        expression: "search.etdStart"
                      }
                    }),
                    _c(
                      "span",
                      { staticStyle: { color: "#dfe4ed", padding: "0 4px" } },
                      [_vm._v("—")]
                    ),
                    _c("el-date-picker", {
                      staticStyle: { width: "173px" },
                      attrs: {
                        no: "etdEnd",
                        "value-format": "yyyy-MM-dd",
                        placeholder: _vm.$t("SystemMonitor.EndDate")
                      },
                      model: {
                        value: _vm.search.etdEnd,
                        callback: function($$v) {
                          _vm.$set(_vm.search, "etdEnd", $$v)
                        },
                        expression: "search.etdEnd"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticStyle: { display: "block" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.fetchList }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "250005",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.search.total > 0,
                      expression: "search.total>0"
                    }
                  ],
                  attrs: {
                    "config-module": "250005",
                    total: _vm.search.total,
                    page: _vm.search.pageNum,
                    limit: _vm.search.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.search, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.search, "pageSize", $event)
                    },
                    pagination: _vm.fetchList
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }